import Vue from 'vue';
import App from './infrastructure/vue/App.vue';
import router from './infrastructure/vue/router';
import vuetify from './infrastructure/vue/plugins/vuetify';
import store from './infrastructure/vue/store';

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');
